import { Chip } from '@mui/material';

interface IBooksStatusProps {
  status: number;
}

const BooksStatus = ({ status }: IBooksStatusProps ) => {
  const renderCorrectStatus = () => {
    switch ( status ) {
      case 1:
        return <Chip label="Inactivo" sx={{ borderColor: 'red', color: 'red' }} variant="outlined" />;
      case 0:
        return <Chip label="Activo" sx={{ borderColor: 'green', color: 'green' }} variant="outlined" />;
      case 2:
        return <Chip label="Bloqueado" sx={{ borderColor: 'yellow', color: 'yellow' }} variant="outlined" />;
      default:
        return <Chip label="Inactivo" sx={{ borderColor: 'red', color: 'red' }} variant="outlined" />;
    }
  };

  return (
    <>
      { renderCorrectStatus() }
    </>
  );
};

export default BooksStatus;
